<template>
  <div class="header box">
    <div class="container clear">
        <div class="logo fl">
            <img src="../assets/images/logo.png" alt="加载失败">
        </div>
        <div class="fl conter_right">
            <ul>
                <li>
                    <router-link to="/home">

                        <img class="home-icon" src="../assets/images/home/icon_home.png" alt="加载失败" width="24px" height="21px">
                        <span>首页</span>

                    </router-link>
                </li>
                <li>
                    <router-link to="/flowCenter">
                        <img src="../assets/images/home/icon_flow.png" alt="加载失败" width="23px" height="21px">
                        <span>流量中心</span>

                    </router-link>
                </li>
                <li>
                    <router-link to="/userCenter">
                        <img src="../assets/images/home/icon_info.png" alt="加载失败" width="23px" height="21px">
                        <span>个人中心</span>

                    </router-link>
                </li>
            </ul>
        </div>
        <div class="fr login_register">
            <ul>
                <!-- <li class="login">
                    <router-link to="/register">
                        <img src="../assets/images/home/icon_register.png" alt="加载失败" width="25px" height="25px">
                        <span v-if="isLogin">{{userInfo}}</span>
                    </router-link>
                </li>
                <li class="register">
                    <router-link to="/login">
                        {{login}}
                    </router-link>
                </li> -->
                <img src="../assets/images/home/icon_register.png" alt="加载失败" width="23px" height="21px">
                <router-link to="/register" v-if="isLogin || infoStatus">注册</router-link>

                <span v-else class="">{{username}} <i class="modify" @click="modify">修改密码</i> </span>
                <i class="icon"></i>
                <router-link to="/login" v-if="isLogin || infoStatus" style="color: #FF8401;">登录</router-link>

                <span class="loginOut" v-else @click="loginOut">退出登录</span>
            </ul>
        </div>
    </div>
    <el-dialog
        title="修改密码"
        :visible.sync="centerDialogVisible"
        width="30%"
        center>
        <el-form :model="modifyPwd" status-icon ref="modifyPwd" label-width="100px" class="demo-ruleForm">
            <el-form-item label="手机号" prop="phone">
                <el-input type="number" disabled v-model="modifyPwd.phone" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="图形验证码" prop="picCode">
                <el-input type="text" v-model="modifyPwd.picCode" auto-complete="off" style="width: 50%;"></el-input>
                <img :src="captchaPath" class="login-captcha" @click="getCaptcha" alt="加载失败">
            </el-form-item>
            <el-form-item label="新密码" prop="pass">
                <el-input type="password" v-model="modifyPwd.pass" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="modifyPwd.checkPass" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="短信验证码" prop="msgCode">
                <el-input type="number" style="width: 50%;" v-model="modifyPwd.msgCode" auto-complete="off"></el-input>
                <div class="btn-code">
                    <el-button type="primary" v-if="showCode" @click="getCode">获取验证码</el-button>
                    <el-button type="primary" disabled v-if="!showCode" class="count">{{countCode}}s重新获取</el-button>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定 修 改</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/axios'
import { getUUID } from '@/utils'
import httpRequest from '@/utils/httpRequest'
export default {
  inject: ['reload'],
  name: 'Header',
  data () {
    return {
      username: null,
      isLogin: false,
      infoStatus: true,
      centerDialogVisible: false,
      modifyPwd: {
        phone: '',
        picCode: '',
        msgCode: '',
        pass: '',
        checkPass: '',
        uuid: ''
      },
      captchaPath: '',
      showCode: true,
      timerCode: null,
      countCode: 0
    }
  },
  created () {
    let _this = this
    this.$root.eventHub.$on('headerEmit', (data) => {
      _this.infoStatus = data
      if (!_this.infoStatus) {
        this.reload()
      }
    })
  },
  methods: {
    loginOut () {
      this.$router.push({path: '/login'})
      this.isLogin = true
    },
    //获取用户信息
    getUserInfo () {
      const _this = this
      let params = {
        token: this.$route.query.token
      }
      //检测权重池用户信息
      try {
        http.qzcLogin(params).then(({ data }) => {
          switch (data.code) {
            case 0:
              const obj = {
                username: data.user.username,
                userId: data.user.userId,
                type: data.user.type
              }
              localStorage.setItem('info', JSON.stringify(obj))
              localStorage.setItem('token', data.user.token)
              this.$router.push({path: '/userCenter'})
              this.reload()
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            case 402:
              _this.$message.error(data.msg)
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    },
    modify () {
      this.getCaptcha()
      this.centerDialogVisible = true
      if (localStorage.getItem('info')) {
        this.modifyPwd.phone = JSON.parse(localStorage.getItem('info')).username
      }
    },
    // 获取图片验证码
    getCaptcha () {
      this.modifyPwd.uuid = getUUID()
      this.captchaPath = httpRequest.adornUrl(`/captcha.jpg?uuid=${this.modifyPwd.uuid}`)
    },
    submitForm () {
      if (this.modifyPwd.phone === '') {
        this.$message.error('请输入手机号')
        return
      }
      if (!(/^1[3456789]\d{9}$/.test(this.modifyPwd.phone))) {
        this.$message.error('手机号码有误，请重填')
        return
      }
      if (this.modifyPwd.pass === '') {
        this.$message.error('请输入新密码')
        return
      }
      if (this.modifyPwd.checkPass === '') {
        this.$message.error('请输入确认密码')
        return
      }
      if (this.modifyPwd.checkPass !== this.modifyPwd.pass) {
        this.$message.error('两次密码不一致')
        return
      }
      if (this.modifyPwd.picCode === '') {
        this.$message.error('请输入图片验证码')
        return
      }
      if (this.modifyPwd.msgCode === '') {
        this.$message.error('请输入手机验证码')
        return
      }
      this.getCaptcha()
      let postData = {
        confirmPwd: this.modifyPwd.checkPass, // 确认密码 ,
        mobile: JSON.parse(localStorage.getItem('info')).username, // 手机号码
        mobileCode: this.modifyPwd.msgCode, // 短信验证码
        pwd: this.modifyPwd.pass, // 新密码
        validateCode: this.modifyPwd.picCode // 图形验证码
      }
      try {
        http.updatePwd(postData).then(({data}) => {
          switch (data.code) {
            case 0:
              this.$message.success('密码修改成功！')
              this.centerDialogVisible = false
              break
            case 401:
              this.$message.error('账号过期，请重新登录')
              this.$router.push({path: '/login'})
              break
            default:
              this.$message.info(data.msg)
              break
          }
        })
      } catch (err) {
        this.$message.error(err)
      }
    },
    // 倒计时获取验证码
    getNumCode () {
      const TIME_COUNT = 60
      if (!this.timerCode) {
        this.countCode = TIME_COUNT
        this.showCode = false
        this.timerCode = setInterval(() => {
          if (this.countCode > 0 && this.countCode <= TIME_COUNT) {
            this.countCode--
          } else {
            this.showCode = true
            clearInterval(this.timerCode)
            this.timerCode = null
          }
        }, 1000)
      }
    },
    // 获取手机验证码
    getCode () {
      if (this.modifyPwd.phone === '') {
        this.$message.error('请输入手机号')
        return
      }
      if (!(/^1[3456789]\d{9}$/.test(this.modifyPwd.phone))) {
        this.$message.error('手机号码有误，请重填')
        return
      }
      if (this.modifyPwd.picCode === '') {
        this.$message.error('请输入图片验证码')
        return
      }
      let postData = {
        mobile: JSON.parse(localStorage.getItem('info')).username,
        uuid: this.modifyPwd.uuid,
        picCode: this.modifyPwd.picCode
      }
      try {
        http.getCode(postData).then(({data}) => {
          if (data.code === 0) {
            this.$message.success('验证码已发送')
            this.getNumCode()
          } else {
            this.$message.info(data.msg)
          }
        })
      } catch (err) {
        this.$message.error(err)
      }
    }

  },
  mounted () {
    //判断是权重池广告跳转
    let url = window.location.href
    if (url.indexOf('token') >= 0) {
      this.getUserInfo()
    }
    if (localStorage.getItem('info')) {
      this.username = JSON.parse(localStorage.getItem('info')).username
      this.infoStatus = false
    }
    if (this.username === null) {
      this.isLogin = true
    } else {
      this.isLogin = false
    }
    if (this.$route.path === '/login' || this.$route.path === '/register' || location.hash === '#/login' || location.hash === '#/register') {
      this.isLogin = true
    }
  },
  beforeDestroy () {
    clearInterval(this.timerCode)
  }
}
</script>

<style lang="less" scoped>
.header {
    background:rgba(111,57,0,1);
    padding: 11px 0;
    padding-left: 99px;
    padding-right: 110px;
    height: 51px;
    .logo {
        margin-right: 219px;
        img {
            vertical-align: text-bottom;
        }
    }
}
.conter_right{
    margin-top: 2px;
    li {
        // margin-right: 41px;
        display: inline-block;
        a {
            font-size:16px;
            color:rgba(255,255,255,1);
            border-right: 1px solid #B88957;
            padding-right: 20px;
            padding-left: 20px;
            display: inline-block;
            vertical-align: middle;
        }

        img {
            vertical-align: middle;
        }
        span {
            display: inline-block;
            vertical-align: middle;
        }
    }
    li:nth-child(1) a{
        padding-left: 0;
    }
    li:nth-child(3) a{
        padding-right: 0;
        border-right: none;
    }
}
.login_register {
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 2px;
    li {
        display: inline-block;
    }
    i {
        font-size: 30px;
    }
    a {
        font-size:16px;
        color:rgba(255,255,255,1);
        vertical-align: middle;
    }
    span {
        display: inline-block;
        vertical-align: middle;
    }
    .register {

        margin-left: 20px;
        a {
            color: #FC6B0E;
            padding-left: 20px;
            border-left: 1px solid #B88957;
        }
    }
    img {
        vertical-align: middle;
        margin-right: 5px;
    }
    .loginOut {
      color: red;
      font-size: 12px;
      cursor: pointer;
    }
    .icon {
        display: inline-block;
        width: 1px;
        height: 18px;
        background: #B88957;
        margin-right: 15px;
        margin-left: 15px;
        vertical-align: text-bottom;
    }
    .modify {
        color: red;
        font-size: 12px;
        cursor: pointer;
        &:hover {
            color: #FC6B0E;
        }
    }
}
.login-captcha {
    width: 48%;
    float: right;
    height: 40px;
    vertical-align: middle;
}
.btn-code {
    width: 48%;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue